import styled from 'styled-components'

export const PlaceholderStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px;
`
